'use-strict';

import { IScope } from 'angular';
import { SettingsAPIService } from '../../../shared/api/settings-api.service';
import { ConfigService } from '../../../shared/config/config.service';
import { InterfaceService } from '../../../shared/interface/interface.service';
import { EExternalAPI } from '../../../src/app/@shared-types/api';
import LogService from '../../../src/app/shared/services/log';
import { ToastService, ToastType } from '../../../ui-components/toast/toast.service';
import { MobileExtendedAPIConfig } from '../../../src/app/@shared-types/api/mobile-extended';

/* @ngInject */
export default class JuhuAutoAPIController {
  private $scope: IScope;

  public config: MobileExtendedAPIConfig | null = null;

  public subsidiaries: { [key: string]: string } | null = null;

  public importing = false;

  private settingsApiService: SettingsAPIService;

  private interfaceService: InterfaceService;

  private toastService: ToastService;

  private logService: LogService;

  public notificationAdmins: string | null = null;

  constructor(
    $scope: IScope,
    settingsApiService: SettingsAPIService,
    interfaceService: InterfaceService,
    toastService: ToastService,
    configService: ConfigService,
    logService: LogService,
  ) {
    this.settingsApiService = settingsApiService;
    this.interfaceService = interfaceService;
    this.$scope = $scope;
    this.toastService = toastService;
    this.logService = logService;

    this.subsidiaries = {};
    configService.get('subsidiaries')?.forEach((s) => {
      if (this.subsidiaries) this.subsidiaries[s.id] = s.description;
    });

    this.getConfig();
  }

  private getConfig = async (): Promise<void> => {
    const configs = await this.settingsApiService
      .getAPIConfig<MobileExtendedAPIConfig[]>(EExternalAPI.JUHU_AUTO).catch();

    [this.config] = configs;
    this.interfaceService.applyScope(this.$scope);
  };

  public updateConfig = async (): Promise<void> => {
    if (!this.config) return;

    const processedConfig: MobileExtendedAPIConfig = {
      enabled: this.config.enabled,
      accounts: this.config.accounts.map((a) => ({
        customerId: String(a.customerId),
        name: a.name,
        subsidiaryId: a.subsidiaryId,
      })),
    };

    await this.settingsApiService.updateAPIConfig(EExternalAPI.JUHU_AUTO, processedConfig)
      .then(() => this.toastService.toast(ToastType.SUCCESS, 'Einstellungen gespeichert.'));
  };
}
